import { render, staticRenderFns } from "./customer-info.vue?vue&type=template&id=031b7916&scoped=true"
import script from "./customer-info.vue?vue&type=script&lang=ts"
export * from "./customer-info.vue?vue&type=script&lang=ts"
import style0 from "./customer-info.vue?vue&type=style&index=0&id=031b7916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031b7916",
  null
  
)

export default component.exports